function youtubeId(url) {
  const host = url.hostname.replace(/^(www|m)\./, "")
  if (host === "youtu.be") return url.pathname.split("/")[1]
  if (host !== "youtube.com" && host !== "youtube-nocookie.com") return null
  if (url.searchParams.has("v")) return url.searchParams.get("v")
  const [, kind, id] = url.pathname.split("/")
  return ["embed", "live", "v"].includes(kind) ? id : null
}

function youtubeStart(url) {
  const t = url.searchParams.get("t") || url.searchParams.get("start")
  if (!t) return null
  const [, h = 0, m = 0, s = 0] = t.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/) || []
  return Number(h) * 3600 + Number(m) * 60 + Number(s) || null
}

function vimeoEmbed(url) {
  const host = url.hostname.replace(/^www\./, "")
  if (host !== "vimeo.com" && host !== "player.vimeo.com") return null
  const parts = url.pathname.split("/").filter(Boolean)
  const index = parts.findIndex((part) => /^\d+$/.test(part))
  if (index === -1) return null

  const embed = new URL(`https://player.vimeo.com/video/${parts[index]}`)
  const hash = url.searchParams.get("h") || parts[index + 1]
  if (hash) embed.searchParams.set("h", hash)
  return embed
}

function embedSrc(href) {
  const url = new URL(href.replaceAll("&amp;", "&"))
  let embed = vimeoEmbed(url)

  const id = youtubeId(url)
  if (id) {
    embed = new URL(`https://www.youtube-nocookie.com/embed/${id}`)
    embed.searchParams.set("rel", "0")
    const start = youtubeStart(url)
    if (start) embed.searchParams.set("start", start)
  }

  embed ??= url
  embed.searchParams.set("autoplay", "1")
  return embed.toString()
}

let dialog = null

function getDialog() {
  if (dialog) return dialog

  dialog = document.createElement("dialog")
  dialog.className = "lightbox"
  dialog.innerHTML = `
    <button type="button" class="lightbox__close" data-dialog-close>
      <span aria-hidden="true">&times;</span>
      <span class="visually-hidden">Close</span>
    </button>
    <div class="lightbox__frame"></div>`

  dialog.addEventListener("close", () => {
    dialog.querySelector(".lightbox__frame").replaceChildren()
  })

  document.body.append(dialog)
  return dialog
}

export function initLightbox() {
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-lightbox]")
    if (!link) return
    e.preventDefault()

    const iframe = document.createElement("iframe")
    iframe.src = embedSrc(link.href)
    iframe.title = link.dataset.lightbox || "Video"
    iframe.allow = "autoplay; fullscreen; picture-in-picture"
    iframe.allowFullscreen = true

    const box = getDialog()
    box.setAttribute("aria-label", iframe.title)
    box.querySelector(".lightbox__frame").replaceChildren(iframe)
    box.showModal()
  })
}
